import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RestResponse} from '../models/http/RestResponse.model';
import {OptionsRequestModel} from '../models/http/OptionsRequest.model';
import {environment} from '../../../environments/environment';

/**
 * Request Methods enum
 */
export enum RequestMethod {
  POST = 'POST',
  GET = 'GET',
  PUT = 'PUT',
  DELETE = 'DELETE'
}

@Injectable()
export class RestService {

  constructor(private httpClient: HttpClient) {
  }

  request<T>(method: RequestMethod, module: string, action: string, options?: OptionsRequestModel): Observable<RestResponse<T>> {
    return Observable.create(obs => {
      this.restRequest<RestResponse<T>>(
        method,
        `${environment.api}/${environment.apiVersion}/${module}/${action}`,
        options
      ).subscribe(
        next => obs.next(next),
        error => obs.next(error as RestResponse<any>)
      );
    });
  }

  publicRequest<T>(method: RequestMethod, module: string, action?: string, options?: OptionsRequestModel): Observable<RestResponse<T>> {
    if (options) {
      options.skipToken = true;
    } else {
      options = {skipToken: true};
    }

    let urlRequest;
    if (action) {
      urlRequest = `${environment.api}${module}/${action}`;
    } else {
      urlRequest = `${environment.api}${module}`;
    }

    return Observable.create(obs => {
      this.restRequest<RestResponse<T>>(method, urlRequest, options).subscribe(
        next => obs.next(next),
        error => obs.next(error as RestResponse<any>)
      );
    });
  }

  restRequest<T>(method: RequestMethod, url: string, options?: OptionsRequestModel): Observable<T> {
    if (options && options.skipToken) {
      if (options.headers) {
        options.headers.X_SKIP_TOKEN = '';
      } else {
        options.headers = {
          X_SKIP_TOKEN: ''
        };
      }
      delete options.headers.skipToken;
    }

    return this.httpClient.request<T>(method.toString(), url, options);
  }
}
